/* import __COLOCATED_TEMPLATE__ from './flair-row.hbs'; */
import SelectKitRowComponent from "select-kit/components/select-kit/select-kit-row";
export default SelectKitRowComponent.extend({
  classNames: ["flair-row"]
});